// extracted by mini-css-extract-plugin
export default {"wrap":"j3Ou22","services":"GZLiEw","service":"ZfkWcX","picture":"SjOTxu","subtitle":"Q38wru"};